<template>
  <li class="spire-action-menu__item">
    <slot></slot>
  </li>
</template>

<script>
export default {};
</script>
